//
// DataTreeSortContext.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "./SortState";

var DataTreeSortContext = createModule("commons::DataTreeSortContext", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getSortState: [1],
        getSortedIndicesForDataTreeNode: [[4],1],
    },
    {
        _create: [4],
    },
    ,
]);
export default DataTreeSortContext;
